var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',{attrs:{"disabled":_vm.disabled},domProps:{"textContent":_vm._s(_vm.$tf('reset | filters'))},on:{"click":_vm.dispatchClickEvent}})}
var staticRenderFns = []

export { render, staticRenderFns }